import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { KomitentEmail } from './komitent-email';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-komitent-email-modal-update',
  templateUrl: './komitent-email-modal-update.component.html'
})
export class KomitentEmailModalUpdateComponent extends BaseModalUpdateComponent<KomitentEmail> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentEmail>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
